import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { XCircle } from "@phosphor-icons/react";

export default function BookingCancel() {
  const { t } = useTranslation();
  return (
    <div data-testid="booking-cancel-page" className="min-h-screen bg-sand flex items-center justify-center px-6">
      <div className="max-w-lg w-full border border-line bg-white p-10 text-center">
        <XCircle size={52} weight="light" className="text-terracotta mx-auto" />
        <h1 className="font-serif text-4xl md:text-5xl text-ink mt-6">{t("cancel.title")}</h1>
        <p className="mt-3 text-sm text-ink/60">{t("cancel.sub")}</p>
        <Link
          data-testid="cancel-back"
          to="/"
          className="inline-block mt-8 px-8 py-4 bg-ink text-sand text-xs uppercase tracking-[0.2em] hover:bg-terracotta transition-colors"
        >
          {t("cancel.back")}
        </Link>
      </div>
    </div>
  );
}
